export default "__VITE_ASSET__d95e2242__"